import AntimKaam from './antim_kaam';

function App() {
  return <AntimKaam />;
}

export default App;
